import Footer from "../component/Footer";
import Header from "../component/Header";
import { Link, useLocation, useParams } from "react-router-dom";
import ScrollToTop from "../component/ScrollToTop";

export default function HomeBlog2() {
    const id = useLocation();
    console.log(id.state.id, "id");
    return (
        <>
            <ScrollToTop>
                <Header />
                <div className="breadcumb-wrapper style2 bg-smoke">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="breadcumb-content justify-content-center">
                                    <ul className="breadcumb-menu">
                                        <li>
                                            <a href="/">Home</a>
                                        </li>
                                        <li>
                                            <a href="blog">Blog</a>
                                        </li>
                                        <li>Everything You Should Know About UX in 2025</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* blog-details-area */}
                <section className="blog__details-area space">
                    <div className="container">
                        <div className="blog__inner-wrap">
                            <div className="row justify-content-center">
                                <div className="col-70">
                                    <div className="blog__details-wrap">
                                        <div className="blog__details-thumb">
                                            <img src="./images/blog/blog_details01.jpg" alt="img" />
                                        </div>
                                        <div className="blog__details-content">
                                            <div className="blog-post-meta">
                                                <ul className="list-wrap">
                                                    <li>March 26, 2024</li>
                                                    <li>
                                                        <a href="blog.html">Branding</a>
                                                    </li>
                                                    <li>
                                                        <a href="blog.html">by Ashton Porter</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <h2 className="title">Everything You Should Know About UX in 2025</h2>
                                            <p>
                                                At HopeFly Meta, design is more than how something looks—it’s how it works.
                                                We’ve worked closely with clients across industries to improve their platforms by focusing on simple, human-centered UX strategies.
                                            </p>
                                            <p>
                                                As digital attention spans grow shorter, good UX is no longer optional. It’s what helps users complete tasks faster, enjoy the experience more, and trust your product. This year, our focus has been on accessibility, personalization, and micro-interactions that guide users without overwhelming them.
                                            </p>
                                            <blockquote>
                                                <img
                                                    className="blockquote-icon"
                                                    src="./images/icon/quote.svg"
                                                    alt="img"
                                                />
                                                <p>
                                                    “HopeFly Meta didn’t just redesign our app. They made it feel natural. Now our users actually enjoy spending time on it.
                                                </p>
                                            </blockquote>
                                            <p> — Product Manager, E-Learning Platform</p>
                                            <p>
                                                Our process starts with understanding people—not just pixels. We test real user journeys, uncover friction points, and build flows that feel effortless.
                                            </p>

                                            <div className="blog__details-inner">
                                                <div className="row align-items-center">
                                                    <div className="col-sm-6">
                                                        <div className="blog__details-inner-thumb">
                                                            <img
                                                                src="./images/blog/blog_details02.jpg"
                                                                alt="img"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="blog__details-inner-thumb">
                                                            <img
                                                                src="./images/blog/blog_details03.jpg"
                                                                alt="img"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p>
                                                In a time where every app competes for attention, the best UX is the one that quietly works in the background—so users can focus on what matters to them.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="wrapper">
                    <div class="marquee marquee-wrap">
                        <div class="marquee_group">
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="/service">
                                        <i className="fas fa-star-of-life" />
                                        Business Branding
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Development
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Cloud-based Application
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        AI Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Metaverse Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Marketing and SEO
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Service
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        E-commerce Plugin
                                    </Link>
                                </h6>
                            </div>
                        </div>
                        <div aria-hidden="ture" class="marquee_group">
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="/service">
                                        <i className="fas fa-star-of-life" />
                                        Business Branding
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Development
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Cloud-based Application
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        AI Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Metaverse Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Marketing and SEO
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Service
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        E-commerce Plugin
                                    </Link>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </ScrollToTop>
        </>
    );
}
